import { ITransitionHandlerOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/slide-transition/interface';
import { ImplementationType, TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import { IAnimationRenderer } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/slide-transition/render/interface';
import { CommonRenderer } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/slide-transition/render/common-renderer';
import { FlashRenderer } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/slide-transition/render/flash-renderer';

export function createAnimationRenderer(options: ITransitionHandlerOptions): IAnimationRenderer | undefined {
    const renderType = options.slideModel.transition?.getImplementationType();
    if (renderType === ImplementationType.FLAT || renderType === ImplementationType.PRESERVE_3D) {
        return new CommonRenderer(options);
    }
    if (renderType === ImplementationType.CUSTOM) {
        const transitionType = options.slideModel.transition?.type;
        switch (transitionType) {
            case TransitionType.FLASH:
                return new FlashRenderer(options);
        }
    }
}
